import React from 'react';
import { Heading2, Heading3, SeparatorHorizontal, SquareDashed, TicketPercent } from 'lucide-react';
import { getElementFieldTypeIcon } from '@dashboard/services/pageFieldTypes';

const LAYOUT_ICONS = {
  group: SquareDashed,
  heading: Heading2,
  subheading: Heading3,
  divider: SeparatorHorizontal,
  'discount-code': TicketPercent,
};

export default function PickerItemIcon({ item }) {
  if (item.kind !== 'field') {
    const Icon = LAYOUT_ICONS[item.id];
    return <Icon className="size-4 shrink-0" aria-hidden="true" />;
  }
  return (
    <span className="flex size-4 shrink-0 items-center" aria-hidden="true">
      {getElementFieldTypeIcon(item.element)}
    </span>
  );
}
